module.exports = {"title":"Contact me","layout":"page","path":"/contact","body":"<p>You can find me on all the major social network sites. I’ve also been known to hang around various web development related Freenode IRC channels. Feel free to contact me:</p>\n<p><strong><em>Email:</em></strong> <a href=\"mailto:bmckimmons@me.com\">bmckimmons@me.com</a></p>\n<p><strong><em>IRC Nickname:</em></strong> ideleteme or delete</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./pages/contact/index.md
// module id = 517
// module chunks = 0